(() => {
  'use strict';

  let requestInProgress = false;
  let refreshTimer = null;

  const root = () => window.Shopify?.routes?.root || '/';
  const normalize = (value) => String(value || '').trim().toLowerCase();

  function isNonPhysicalProjectLine(item) {
    const properties = item?.properties || {};
    const lineType = normalize(properties['_ME Line Type']);
    const groupId = String(properties['_ME Design Group'] || '').trim();
    if (groupId) return lineType !== 'garment';
    return lineType === 'addon';
  }

  function physicalCount(cart) {
    return (cart?.items || []).reduce((total, item) => {
      if (isNonPhysicalProjectLine(item)) return total;
      return total + (Number(item.quantity) || 0);
    }, 0);
  }

  function renderCount(count) {
    const text = String(count);

    document.querySelectorAll('[data-me-physical-cart-count]').forEach((node) => {
      node.textContent = text;
      node.classList.toggle('hidden', count === 0);
      const bubble = node.closest('.cart-bubble');
      if (bubble) {
        bubble.classList.toggle('visually-hidden', count === 0);
        bubble.toggleAttribute('data-maintain-ratio', count > 0);
      }
    });

    document.querySelectorAll('.theme-drawer__badge').forEach((node) => {
      node.textContent = text;
      node.classList.toggle('visually-hidden', count === 0);
      node.toggleAttribute('data-maintain-ratio', count > 0);
    });

    document.querySelectorAll('[ref="cartItemCount"]').forEach((node) => {
      node.textContent = String(count);
    });

    document.querySelectorAll('[data-me-physical-cart-count-label]').forEach((node) => {
      node.textContent = `Total physical products in cart: ${count}`;
    });
  }

  async function refresh() {
    if (requestInProgress) return;
    requestInProgress = true;
    try {
      const response = await fetch(`${root()}cart.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Unable to read the cart.');
      renderCount(physicalCount(await response.json()));
    } catch (error) {
      console.warn('Moments Etched physical cart count:', error);
    } finally {
      requestInProgress = false;
    }
  }

  function schedule(delay = 80) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, delay);
  }

  document.addEventListener('DOMContentLoaded', () => schedule(0));
  document.addEventListener('cart:update', () => schedule());
  document.addEventListener('cart:refresh', () => schedule());
  document.addEventListener('product:added', () => schedule());
  document.addEventListener('moments:cart-updated', (event) => {
    const cart = event.detail?.cart;
    if (cart) renderCount(physicalCount(cart));
    else schedule(0);
  });
})();
